import React from "react";

import styles from "./used_pass_count_bar.module.css";
import { Spacer } from "./spacer";

interface UsedPassCountBarProps {
  usedCount: number;
  totalCount: number;
  totalBarColor?: string;
  usedBarColor?: string;
}

export function UsedPassCountBar({
  usedCount,
  totalCount,
  totalBarColor,
  usedBarColor,
}: UsedPassCountBarProps) {
  return (
    <div>
      <div className={styles.countTextWrapper}>
        <div className={styles.usedCountText}>{usedCount} used</div>
        <div className={styles.totalCountText}>
          {totalCount - usedCount} remaining
        </div>
      </div>
      <Spacer size={12} />
      <div
        style={totalBarColor ? { background: totalBarColor } : {}}
        className={styles.totalBar}
      >
        <div
          className={styles.usedBar}
          style={{
            width: `${(usedCount / totalCount) * 100}%`,
            ...(usedBarColor ? { background: usedBarColor } : {}),
          }}
        />
      </div>
    </div>
  );
}
